import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { authContext } from '../../context/AuthContext';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";

class LocationTemplate extends Component {
    static contextType = authContext;
    constructor(props) {
        super(props);

        this.states = [];
        axios.get('/api/stateCounty/states').then((result) => {
            result.data.states.forEach((u) => {
                this.states.push({
                    label: u, value: u
                });
            });
        }).catch(error => {
            console.log("error:" + error);
            this.setState({
                error: error.message
            });
        });

        this.state = {
            counties: [],
            error: null,
            id: this.props.match.params.id,
            name: '',
            countyCode: '',
            city: '',
            street: '',
            stateCode: '',
            zipCode: '',
            mapURL: ''
        }
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    onStateChange = (event, value) => {
        let selected = value;
        if (selected === null) {
            this.setState({
                stateCode: '',
                countyCode: '',
                counties: []
            })
            return;
        }

        let selectedState = selected.value;
        axios('/api/stateCounty/county/' + selectedState, {
            method: 'GET'
        })
            .then(res => res.data)
            .then(result => {
                let county = [];
                result.map((u) =>
                    county.push({ label: u.stateCountyName, value: u.stateCountyName })
                );
                this.setState({
                    counties: county
                })
            }).catch(error => {
                console.log("error:" + error);
                this.setState({
                    error: error.message
                });
            });

        this.setState({ stateCode: JSON.parse(JSON.stringify(selected)) });
    }

    onCountyChange = (event, value) => {
        let selected = value;
        if (selected === null) {
            this.setState({
                countyCode: ''
            })
            return;
        }

        this.setState({ countyCode: JSON.parse(JSON.stringify(selected)) });
    }

    onCreate = (event) => {
        let token = sessionStorage.getItem('accessToken');
        let url = "/api/locationTemplate";

        let data = {
            name: this.state.name,
            countyCode: this.state.countyCode.value,
            city: this.state.city,
            street: this.state.street,
            stateCode: this.state.stateCode.value,
            zipCode: this.state.zipCode,
            mapURL: this.state.mapURL,
            byUsername: this.context.user.username,
        }
        axios(url, 
             {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }, data})
        .then(response => {
            if (response.status === 200) {
                this.props.history.goBack();
            }
        });
    }

    onUpdate = (event) => {
        let token = sessionStorage.getItem('accessToken');
        let url = "/api/LocationTemplate/" + this.state.id;

        let data = {
            name: this.state.name,
            countyCode: this.state.countyCode.value,
            city: this.state.city,
            street: this.state.street,
            stateCode: this.state.stateCode.value,
            zipCode: this.state.zipCode,
            mapURL: this.state.mapURL,
            byUsername: this.context.user.username,
        }
        axios(url, 
             {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            data})
        .then(response => {
            if (response.status === 200) {
                this.props.history.goBack();
            }
        });
    }

    componentDidMount() {
        if (this.props.match.params.id !== undefined) {
            var url = "/api/locationTemplate/" + this.props.match.params.id;

            axios.get(url)
                .then((p) => {
                    this.setState({
                        id: p.data.locTemplate.ID,
                        name: p.data.locTemplate.name,
                        countyCode: { label: p.data.locTemplate.countyCode, value: p.data.locTemplate.countyCode },
                        city: p.data.locTemplate.city,
                        street: p.data.locTemplate.street,
                        stateCode: { label: p.data.locTemplate.stateCode, value: p.data.locTemplate.stateCode },
                        zipCode: p.data.locTemplate.zipCode,
                        mapURL: p.data.locTemplate.mapURL,
                    });
                });
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <ValidatorForm
                noValidate
                onSubmit={this.state.id === undefined ? this.onCreate : this.onUpdate}
            >
                <Fragment>
                    <PageHeader
                        title={"Location Template"}
                        cancel={this.props.history.goBack}
                        actionButtons={[{ label: this.state.id === undefined ? "Add" : "Update" }]}
                    />

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextValidator
                                label="Name"
                                type="text"
                                name='name'
                                value={this.state.name}
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                validators={['required']}
                                errorMessages={['Name is required']}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextValidator
                                id="standard-basic"
                                label="Address"
                                type="text"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.street}
                                name='street'
                                validators={['required']}
                                errorMessages={['Address is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <TextValidator
                                id="standard-basic"
                                label="City"
                                type="text"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.city}
                                name='city'
                                validators={['required']}
                                errorMessages={['City is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <Autocomplete
                                id="stateCode"
                                options={this.states}
                                getOptionLabel={(option) => option.label ? option.label : "" }
                                isOptionEqualToValue={(option, val) => val === "" || option.value === val.value}
                                value={this.state.stateCode || null }
                                onChange={this.onStateChange}
                                className={[classes.autoComplete].join(' ')}
                                renderInput={(params) => <TextValidator {...params}
                                    label="State"
                                    validators={['required']}
                                    errorMessages={['State is required']}
                                    value={this.state.stateCode}
                                    required
                                />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <Autocomplete
                                id="countyCode"
                                options={this.state.counties}
                                getOptionLabel={(option) => option.label ? option.label : "" }
                                isOptionEqualToValue={(option, val) => val === "" || option.value === val.value}
                                value={this.state.countyCode || null }
                                onChange={this.onCountyChange}
                                disabled={!this.state.stateCode}
                                className={[classes.autoComplete].join(' ')}
                                renderInput={(params) => <TextValidator {...params}
                                    label="County"
                                    validators={['required']}
                                    errorMessages={['County is required']}
                                    value={this.state.countyCode}
                                    required
                                />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <TextValidator
                                id="standard-basic"
                                label="Zipcode"
                                type="number"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.zipCode}
                                name='zipCode'
                                validators={['required']}
                                errorMessages={['Zipcode is required']}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextValidator
                                id="standard-basic"
                                label="Map URL"
                                type="text"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.mapURL}
                                name='mapURL'
                                validators={['required']}
                                errorMessages={['Map URL is required']}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </Fragment>
            </ValidatorForm>
        );
    }
}

// export default LocationTemplate;
export default withStyles(styles, { withTheme: true })(LocationTemplate);
